(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const variantData = section.querySelector('[data-variants]');
      const select = section.querySelector('[data-variant-select]');
      if (!variantData || !select) return;
      let variants;
      try { variants = JSON.parse(variantData.textContent); } catch { return; }
      function updateImage(src, alt) {
        const container = section.querySelector('[data-main-image]');
        if (!container || !src) return;
        let img = container.querySelector('img');
        if (!img) { container.replaceChildren(); img = document.createElement('img'); container.appendChild(img); }
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.src = src; if (alt !== undefined) img.alt = alt;
        section.querySelectorAll('[data-image-url]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.imageUrl === src)));
      }
      section.querySelectorAll('[data-image-url]').forEach(button => button.addEventListener('click', () => updateImage(button.dataset.imageUrl, button.dataset.imageAlt)));
      select.addEventListener('change', () => {
        const variant = variants.find(item => String(item.id) === select.value);
        if (!variant) return;
        section.querySelector('[data-price]').textContent = variant.price;
        const compare = section.querySelector('[data-compare]');
        compare.textContent = variant.compare; compare.hidden = !variant.onSale;
        const availability = section.querySelector('[data-availability]');
        availability.textContent = variant.available ? 'Available' : 'Sold out';
        const add = section.querySelector('[data-add-to-cart]');
        add.disabled = !variant.available; add.querySelector('span').textContent = variant.available ? 'Add to cart' : 'Sold out';
        const quantity = section.querySelector('[data-quantity]');
        quantity.min = variant.min || 1; quantity.step = variant.increment || 1;
        if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max');
        quantity.value = variant.min || 1;
        const planSelect = section.querySelector('[data-selling-plan]');
        if (planSelect) {
          const oneTime = planSelect.querySelector('option[value=""]');
          const previous = planSelect.value;
          planSelect.replaceChildren();
          if (oneTime) planSelect.appendChild(oneTime);
          variant.plans.forEach(plan => {
            const option = document.createElement('option'); option.value = String(plan.id); option.textContent = `${plan.name} — ${plan.price}`; planSelect.appendChild(option);
          });
          if ([...planSelect.options].some(option => option.value === previous)) planSelect.value = previous;
        }
        updateImage(variant.image);
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('details[open]').forEach(details => { if (details.classList.contains('departments') || details.classList.contains('filter')) details.open = false; }); });
  document.addEventListener('click', event => document.querySelectorAll('.departments[open], .filter[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; }));
})();
